export const TIPOSCONTRATO = {
  COM_COOBRIGACAO: 1,
  SEM_COOBRIGACAO: 2,
  COM_COOBRIGACAO_E_GARANTIA_IMOVEL: 3,
  COM_COOBRIGACAO_COMEX: 4
};
